import { render, staticRenderFns } from "./cumulAbnormal.vue?vue&type=template&id=3f14d5e8&scoped=true"
import script from "./cumulAbnormal.vue?vue&type=script&lang=js"
export * from "./cumulAbnormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f14d5e8",
  null
  
)

export default component.exports